import { cn } from "lib/utils"
import React from "react"

interface StatusTagProps {
  status?: keyof typeof StatusTagEnum
  icon?: React.ReactNode
  children?: React.ReactNode
  noBorder?: boolean
  className?: string
}

const defaultClassName = "inline-flex items-center gap-2 capitalize font-semibold py-[5px] px-2 rounded-lg text-xs leading-3"

export const StatusTagEnum = {
  warning: "warning",
  error: "error",
  success: "success",
  info: "info",
  orange: "orange",
}

export function getStatusProps(status?: keyof typeof StatusTagEnum) {
  switch (status) {
    case "warning":
      return {
        className: "!bg-amber-500/20 !text-amber-700 dark:!text-amber-200 dark:!bg-amber-500/10 border-amber-500/10",
        icon: <IconMageExclamationTriangleFill className="!size-[16px] text-amber-600" />,
      }
    case "orange":
      return {
        title: "Necessário ler QR-Code",
        bg: "#e67e22",
        description: "Leia o QRCode com seu celular na página do canal para conectar.",
        className: "!bg-orange-500/15 !text-orange-700 border-orange-500/10 dark:!text-orange-500",
        icon: <IconMageQrCodeFill className="!size-[16px] text-orange-600" />,
      }
    case "error":
      return {
        className: "!bg-red-500/15 !text-red-700 border-red-500/10 dark:!text-red-500",
        icon: <IconMageExclamationCircleFill className="!size-[16px] text-red-600" />,
      }
    case "success":
      return {
        className: "!bg-[#cbf4c9] dark:!bg-green-500/15 !text-[#0e6245] dark:!text-green-500 border-green-500/10 font-bold",
      }
    case "info":
      return {
        // className: "!bg-fuchsia-500/15 !text-fuchsia-700 dark:!text-fuchsia-500 border-fuchsia-500/10",
        className: "!bg-sky-500/15 !text-sky-700 dark:!text-sky-500 border-sky-500/10",
      }
    default:
      return {
        className: "!bg-stone-500/15 !text-stone-700 border-stone-500/10 dark:!text-stone-300 dark:!bg-stone-500/20",
      }
  }
}

function StatusTag(props: StatusTagProps) {
  const { className, icon } = getStatusProps(props.status)
  const finalIcon = props.icon || (props.icon !== false && icon)

  return (
    <span
      className={cn(defaultClassName, className, !!finalIcon && "pl-1.5", !props.noBorder && "!border-1 border-solid", props.className)}
    >
      {finalIcon}
      {props.children}
    </span>
  )
}

export default StatusTag
